<template>
  <div v-if="lowInventoryAlert" class="low-inventory-alert">
    <icon-warning />

    <span
      class="low-inventory-alert__text text-mobile-paragraph-xs-regular text-desktop-paragraph-xs-regular"
      v-text="$string('product.variant.low_inventory_alert_text')"
    />
  </div>
</template>

<script>
/**
 * Vue: Low inventory alert (low-inventory-alert)
 * -----------------------------------------------------------------------------
 * An alert, which shows if the product variant has low inventory.
 *
 * @param {Object} variant - Formatted variant object.
 *
 */
import IconWarning from '~icons/general/warning.svg';

export default {
  name: 'LowInventoryAlert',

  components: {
    IconWarning,
  },

  props: {
    variant: {
      type: [Boolean, Object],
      default: false,
      required: true,
    },
  },

  computed: {
    /**
     * Calculate if variant has lowInventoryAlert
     * @returns {Boolean}
     */
    lowInventoryAlert() {
      if (
        this.variant.inventory === 0 ||
        this.variant.availableState === 'sold-out' ||
        this.variant.availableState === 'back-soon'
      ) {
        return '';
      }

      const threshold =
        this.variant.lowInventoryThreshold > 0
          ? this.variant.lowInventoryThreshold
          : this.$variable('product.lowInventoryThreshold');

      return this.variant.inventory > 0 && this.variant.inventory <= threshold;
    },
  },
};
</script>

<style lang="scss">
@import './low-inventory-alert';
</style>
